import DataTable from 'react-data-table-component';

const CDataTable = (props) => {

    const title = props.tableTitle === undefined ? "" : props.tableTitle;
    const column = props.column === undefined ? [] : props.column;
    const data = props.data === undefined ? [] : props.data;
    const isPagination = props.isPagination === undefined ? false : true;
    const persistTableHead = props.persistTableHead === undefined ? false : true;
    const fixedHeader = props.fixedHeader === undefined ? false : true;
    const fixedHeaderScrollHeight = props.fixedHeaderScrollHeight === undefined ? "" : props.fixedHeaderScrollHeight;
    const isStriped = props.isStriped === undefined ? false : true;
    const isResponsive = props.isResponsive === undefined ? false : true;
    const isHover = props.isHover === undefined ? false : true;
    const paginationPerPage = props.paginationPerPage === undefined ? 10 : props.paginationPerPage;
    const RowsPerPageOptions = props.paginationRowsPerPageOptions === undefined ? [10,15,20,25] : props.paginationRowsPerPageOptions;
    const customClassLabel = props.customClassLabel === undefined ? "" : props.customClassLabel;
    const customClassDiv = props.customClassDiv === undefined ? "" : props.customClassDiv;
    const customClassInputDiv = props.customClassInputDiv === undefined ? "" : props.customClassInputDiv;



    return (
        <>
        <div className={customClassDiv}>
        <label className={customClassLabel}>{title}</label> 
        <DataTable
            className={customClassInputDiv}
            columns={column}
            data={data}
            pagination={isPagination}
            paginationPerPage={paginationPerPage}
            paginationRowsPerPageOptions={RowsPerPageOptions}
            striped = {isStriped}
            responsive={isResponsive}
            highlightOnHover={isHover}
            fixedHeader={fixedHeader}
            fixedHeaderScrollHeight= {fixedHeaderScrollHeight}
            persistTableHead={persistTableHead}
        />
        </div>
        </>
    );
};

export default CDataTable;